import { get } from './shared';

export const getDetails = get(`/:paymentId/experience/initialization/card`);
